import { type RefObject } from 'react';

import {
  type EmbeddedPaymentElementConfiguration,
  type IntentConfiguration,
} from '@stripe/stripe-react-native';

import {
  currencyCode,
  googlePayConfig,
  merchantDisplayName,
  paymentMethodOptions,
  paymentMethodTypes,
  stripeAppearance,
  walletConfig,
} from './constants';

export function getElementConfig(params: ElementConfigParams): EmbeddedPaymentElementConfiguration {
  const { returnURL, stripeCustomerId, stripeCustomerKey } = params;

  return {
    merchantDisplayName,
    returnURL,
    applePay: walletConfig,
    googlePay: googlePayConfig,
    customerId: stripeCustomerId,
    customerEphemeralKeySecret: stripeCustomerKey,
    appearance: stripeAppearance,
  };
}

export function getIntentConfig(params: IntentConfigParams): IntentConfiguration {
  const { amount, stripeConfirmHandlerRef } = params;

  return {
    confirmHandler: async (paymentResult, shouldSavePaymentMethod, intentCreationCallback) => {
      stripeConfirmHandlerRef?.current?.(
        paymentResult,
        shouldSavePaymentMethod,
        intentCreationCallback,
      );
    },
    // @ts-expect-error - The Stripe SDK is not typed correctly.
    paymentMethodOptions,
    paymentMethodTypes,
    mode: { amount, currencyCode },
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type IntentConfigParams = {
  amount: number;
  stripeConfirmHandlerRef: RefObject<NonNullable<IntentConfiguration['confirmHandler']>>; // prettier-ignore
};

type ElementConfigParams = {
  returnURL: string;
  stripeCustomerId: string;
  stripeCustomerKey: string;
};
